import { getNodeEnv, ENVIRONMENTS } from "./getNodeEnv"
import EnvVars from "../env-vars"

export const getVisionUrl = (): string => {
  switch (getNodeEnv()) {
    case ENVIRONMENTS.burner:
      return EnvVars.VISION_URL
    case ENVIRONMENTS.production:
      return `https://vision.powur.com`
    case ENVIRONMENTS.qa:
      return `https://vision.powur.dev`
    case ENVIRONMENTS.development:
      return `https://vision-trunk.powur.dev`
    case ENVIRONMENTS.staging:
      return `https://vision.powur.cloud`
    case ENVIRONMENTS.codespace:
      return `http://127.0.0.1:4179`
    default:
      return `NODE_ENV not set`
  }
}

export const getPowurUrl = (): string => {
  switch (getNodeEnv()) {
    case ENVIRONMENTS.burner:
      return EnvVars.POWUR_PLATFORM_URL
    case ENVIRONMENTS.production:
      return `https://powur.com`
    case ENVIRONMENTS.qa:
      return `https://powur.dev`
    case ENVIRONMENTS.development:
      return `https://localhost:3000`
    case ENVIRONMENTS.staging:
      return `https://powur.cloud`
    case ENVIRONMENTS.codespace:
      return `https://localhost:3000`
    default:
      return `NODE_ENV not set`
  }
}
